import { lazy } from 'react'

import { ErrorPage } from '../components/ErrorPage'
import { Loader } from '../components/Loader'
import {
  requestThreadMessageProfilePrintDataLoader,
  requestThreadMessageProfileRawDataLoader,
  requestThreadProfilePrintDataLoader,
} from '../components/RequestProfile'
import { APP_STATUS_ERROR } from '../constants/common'
import { ROUTE_PATH_LIST } from '../constants/route'

const EmailMessageProfileRaw = lazy(() =>
  import('../components/Email/EmailMessageProfileRaw').then(m => ({
    default: m.EmailMessageProfileRaw,
  }))
)
const EmailMessageProfilePrint = lazy(() =>
  import('../components/Email/EmailMessageProfilePrint').then(m => ({
    default: m.EmailMessageProfilePrint,
  }))
)
const EmailThreadProfilePrint = lazy(() =>
  import('../components/Email/EmailThreadProfilePrint').then(m => ({
    default: m.EmailThreadProfilePrint,
  }))
)

export function getConnectedRequestThreadRawRoutes() {
  return [
    {
      HydrateFallback: Loader,
      element: <EmailMessageProfileRaw />,
      errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
      loader: requestThreadMessageProfileRawDataLoader,
      path: `/${ROUTE_PATH_LIST.connectedRequestThreads}/${ROUTE_PATH_LIST.mailMessageRaw}`,
    },
    {
      HydrateFallback: Loader,
      element: <EmailMessageProfilePrint />,
      errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
      loader: requestThreadMessageProfilePrintDataLoader,
      path: `/${ROUTE_PATH_LIST.connectedRequestThreads}/${ROUTE_PATH_LIST.mailMessagePrint}`,
    },
    {
      HydrateFallback: Loader,
      element: <EmailThreadProfilePrint />,
      errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
      loader: requestThreadProfilePrintDataLoader,
      path: `/${ROUTE_PATH_LIST.connectedRequestThreads}/${ROUTE_PATH_LIST.mailThreadPrint}`,
    },
  ]
}
